import styled from "styled-components";

import { ColorGrayLightest } from "ds/Core";

export const StyledCountryItem = styled.li`
  padding: ${({ theme: { spaces } }) => `${spaces.s + spaces.xs}px ${spaces.s}px`};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;

  &:hover {
    background-color: ${ColorGrayLightest};
  }
`;
